<template>
    <div class="column-layout">
        <el-form :model="adoptedServc" ref="adoptedServcInfo" :rules="adoptedServcRules">
            <div class="content-caption dashed">
                <span>分类信息</span>
                <a class="swb-btn-link" v-if="adoptedServc.ssuId == -1 || adoptedServc.ssuId == null" @click="selectCatInfo()">选择</a>
            </div>
            <div class="simple-form">
                <div class="form-group">
                    <div class="form-label">
                        <label class="required">分类名称</label>
                    </div>
                    <div class="form-value ">
                        <el-form-item prop="servcCatName">
                            <el-input class="width-2x bottom-line" :disabled="true" v-model="adoptedServc.servcCatName"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label class="required">品牌名称</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="servcBrandName">
                            <el-input class="width-2x bottom-line" :disabled="true" v-model="adoptedServc.servcBrandName"></el-input>
                        </el-form-item>
                    </div>
                </div>
            </div>
            <div class="content-caption dashed">
                <span>服务信息</span>
            </div>
            <div class="simple-form">
                <div class="form-group">
                    <div class="form-label">
                        <label class="required">名称</label>
                    </div>
                    <div class="form-value ">
                        <el-form-item prop="name">
                            <el-input class="width-2x " :disabled="adoptedServc.ssuId != -1 && adoptedServc.ssuId != null" v-model="adoptedServc.name"></el-input>
                        </el-form-item>
                    </div>
                </div>
            </div>
            <div class="content-caption dashed">
                <span>价格信息</span>
            </div>
            <div class="simple-form">
                <div class="form-group">
                    <div class="form-label">
                        <label>价格</label>
                    </div>
                    <div class="form-value ">
                        <el-form-item prop="price">
                            <el-input type="number" class="width-2x " :disabled="adoptedServc.ssuId != -1 && adoptedServc.ssuId != null" v-model="adoptedServc.price"></el-input>
                            <div class="form-tips">元</div>
                        </el-form-item>
                    </div>
                </div>
            </div>
            <div class="content-caption dashed">
                <span>要求信息</span>
            </div>
            <div class="simple-form">
                <div class="form-group">
                    <div class="form-label">
                        <label>响应时长（分钟）</label>
                    </div>
                    <div class="form-value ">
                        <el-form-item prop="rspTimeMi">
                            <el-input class="width-2x " :disabled="adoptedServc.ssuId != -1 && adoptedServc.ssuId != null" v-model="adoptedServc.rspTimeMi"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>上门时长（分钟）</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="arriveTimeMi">
                            <el-input class="width-2x " :disabled="adoptedServc.ssuId != -1 && adoptedServc.ssuId != null" v-model="adoptedServc.arriveTimeMi"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>维修时长（分钟）</label>
                    </div>
                    <div class="form-value ">
                        <el-form-item prop="repairedTimeMi">
                            <el-input class="width-2x " :disabled="adoptedServc.ssuId != -1 && adoptedServc.ssuId != null" v-model="adoptedServc.repairedTimeMi"></el-input>
                        </el-form-item>
                    </div>
                </div>
            </div>
            <div class="content-caption dashed">
                <span>其他</span>
            </div>
            <div class="simple-form">
                <div class="form-group">
                    <div class="form-label">
                        <label>星级</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="favorLevel">
                            <el-rate v-model="adoptedServc.favorLevel"></el-rate>
                        </el-form-item>
                    </div>
                </div>
            </div>
            <div class="simple-form">
                <div class="form-group">
                    <div class="form-label">
                        <label>备注</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="desc">
                            <el-input class="width-2x" v-model="adoptedServc.desc" type="textarea" placeholder="请输入备注信息"></el-input>
                        </el-form-item>
                    </div>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import devcReqrApi from '../../api/devcReqr'

    import { servcCategAndBrandSelectDlg } from './dialog'
    //
    export default {
        name: 'swb-adopted-servc-save',
        desc: '采购入选商品-保存',
        props: ["id"],
        data: function () {
            var checkPrice = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback()
                } else {
                    if(!Utils.isMoneyStr(value)) {
                        callback(new Error("请填写正确的价格"))
                    } else {
                        callback()
                    }
                }
            };
            var checkMi = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback()
                } else {
                    if(!Utils.isNaturalStr(value, true)) {
                        callback(new Error("请填写正确的时长"))
                    } else {
                        callback()
                    }
                }
            };
            var checkName = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error("名称不能为空"))
                } else {
                    callback()
                }
            };
            return {
                adoptedServc: {},
                adoptedServcRules: {
                    price: [{validator: checkPrice, trigger: 'blur'}],
                    rspTimeMi: [{validator: checkMi, trigger: 'blur'}],
                    arriveTimeMi: [{validator: checkMi, trigger: 'blur'}],
                    repairedTimeMi: [{validator: checkMi, trigger: 'blur'}],
                    name: [{validator: checkName, trigger: 'blur'}],
                }
            }
        },
        created: function () {
            if(!Utils.isNoB(this.id)) {
                this.getAdoptedServcById(this.id);
            }
        },
        methods: {
            // 根据id查询对应的信息
            getAdoptedServcById: function (id) {
                let self = this;
                let postData = {
                    id: id
                };
                devcReqrApi.getAdoptedServcById(postData, function (result) {
                    if(result.type == "info") {
                        self.adoptedServc = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            /**
             * 选择分类和品牌
             */
            selectCatInfo: function () {
                let self = this;
                let adoptedServc = self.adoptedServc;
                servcCategAndBrandSelectDlg(null, function (result) {
                    console.log(result);
                    adoptedServc.servcCatId = result.cat.id;
                    adoptedServc.servcCatName = result.cat.name;
                    adoptedServc.servcBrandId = result.catBrand.brandId;
                    adoptedServc.servcBrandName = result.catBrand.servcBrand.name;
                    adoptedServc.name = result.cat.name + result.catBrand.servcBrand.name;
                    self.adoptedServc = Utils.merge({}, adoptedServc);
                })
            },
            getDlgResult: function () {
                let result = {};
                let adoptedServc = this.adoptedServc;
                this.$refs['adoptedServcInfo'].validate(function (valid) {
                    if(valid) {
                        if(Utils.isNoB(adoptedServc.servcCatId)) {
                            result.type = "warn";
                            result.message = "请选择分类信息";
                        } else {
                            result.data = adoptedServc;
                            result.type = "info";
                        }
                    } else {
                        result.type = 'warn';
                        result.message = '校验失败';
                    }
                });

                return result;
            },
        }
    }

</script>
<style>
    .adopted-device .el-tree.el-tree--highlight-current {
        height: 400px;
        overflow-y: auto;
    }
</style>



// WEBPACK FOOTER //
// src/compo/retailer/AdoptedServcSave.vue